import {Component} from "@angular/core";
import {SalesJournalSearchModel} from "../sales-journal-search.model";
import {SalesJournalEntityModel} from "../sales-journal-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {ActivatedRoute} from "@angular/router";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-sales-journal-search-page",
    templateUrl: "./sales-journal-search-page.component.html",
    providers: [provideSearchModel(SalesJournalSearchModel), provideEntityModel(SalesJournalEntityModel)]
})
export class SalesJournalSearchPageComponent extends AbstractSearchPage {

    public static readonly MAINTENANCE_EDIT_PAGE = "sales-maintenance";
    public static readonly MAINTENANCE_SEARCH_PAGE = "sales-maintenance-search";

    maintenanceMode: boolean;
    overrideEditRoute: string;

    constructor(private searchModel: SalesJournalSearchModel, activatedRoute: ActivatedRoute) {
        super();
        activatedRoute.data.subscribe((data) => {
            this.maintenanceMode = data["maintenance"];
            if (this.maintenanceMode) {
                this.overrideEditRoute = SalesJournalSearchPageComponent.MAINTENANCE_EDIT_PAGE;
            }
        });
    }

    prepareInitialFilter(): void {
        const currentDate: Date = new Date();
        currentDate.setHours(0, 0, 0, 0);
        this.searchModel.filter["fromDate"] = currentDate;
        if (this.isSelectMode()) {
            const integratedOrderId: string = this.extendedSearchParams.searchParams["integratedOrderId"];
            const fromDate: Date = this.extendedSearchParams.searchParams["fromDate"];
            if (integratedOrderId) {
                this.searchModel.filter["integratedOrderId"] = integratedOrderId;
                this.searchModel.filter["fromDate"] = fromDate;
                this.searchFormComponent.setSelectedFormFields(["integratedOrderId"]);
            }
        }
    }

    getIntegratedDeliveryTrackingUrl(dataItem: any) {
        return dataItem.integratedDeliveryTrackingUrl;
    }
}
